/* eslint-disable eqeqeq */
/*
 * One-Minute Maths
 * Copyright © 2021 - 2024 White Rose Maths
 * SubitiseArray.web.js -
 */

import React from 'react';
import PropTypes from 'prop-types';
import SubitiseElement from './SubitiseElement';
import TenFrameElement from './TenFrameElement';
import { SubitisingCategoryName } from '../../categories';
import './SubitisingScreen.web.css';

export default class SubitiseArray extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {

    if (this.props.hide) {

      return (
        <div/>
      );
    }

    if (this.props.data.category == SubitisingCategoryName.FIVE_FRAME_1) {
      const { formation } = this.props.data;
      const row = [];
      const numCols = 5;

      for (let i = 0; i < numCols; i++) {
        if (formation[0][i] == 1) {
          row.push(
            <TenFrameElement key={`element${i}`} colour={this.props.data.colour} />
          );
        } else if (formation[0][i] == 2) {
          row.push(
            <TenFrameElement key={`element${i}`} colour={this.props.data.colour} />
          );
        } else {
          row.push(
            <TenFrameElement key={`element${i}`} colour="clear" object={undefined} />
          );
        }
      }

      return (
        <div id="subitising_ten_frame">
          {row}
        </div>
      );
    }

    // Show a 10 frame
    if (this.props.data.category == SubitisingCategoryName.TEN_FRAME_1) {

      const { formation } = this.props.data;

      const row = [];
      const numCols = 5;
      const numRows = 2;

      for (let i = 0; i < numRows; i++) {
        for (let j = 0; j < numCols; j++) {
          // const elementNum = (i + 1) * (j + 1);
          if (formation[i][j] == 1) {
            row.push(
              <TenFrameElement key={`element${i}.${j}`} colour={this.props.data.colour} />
            );
          } else if (formation[i][j] == 2) {
            row.push(
              <TenFrameElement key={`element${i}.${j}`} colour={this.props.data.colour} />
            );
          } else {
            row.push(
              <TenFrameElement key={`element${i}.${j}`} colour="clear" object={undefined} />
            );
          }
        }
      }

      return (
        <div id="subitising_ten_frame">
          {row}
        </div>
      );
    }

    let row = [];
    const cols = [];

    const { formation } = this.props.data;
    const numRows = 5;
    const numCols = 5;

    for (let i = 0; i < numRows; i++) {
      for (let j = 0; j < numCols; j++) {
        // const elementNum = (i + 1) * (j + 1);
        if (formation[i][j] == 1) {
          row.push(
            <SubitiseElement key={`element${i}.${j}`} colour={this.props.data.colour} object={this.props.data.object} />
          );
        } else if (formation[i][j] == 2) {
          row.push(
            <SubitiseElement key={`element${i}.${j}`} colour={this.props.data.colour2} object={this.props.data.object} />
          );
        } else {
          row.push(
            <SubitiseElement key={`element${i}.${j}`} colour="clear" object={undefined} />
          );
        }
      }

      cols.push(
        <div id="subitise_row" key={`row${i}`}>
          {row}
        </div>
      );
      row = [];
    }

    return (

      <div>{cols}</div>

    );
  }
}

SubitiseArray.propTypes = {
  props: PropTypes.object,
  data: PropTypes.object,
  hide: PropTypes.bool
};
